import * as tslib_1 from "tslib";
import { StoryAbstract } from '../shared/story-abstract';
var AwardsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AwardsComponent, _super);
    function AwardsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwardsComponent.prototype.getTemplateBlockGroups = function (storyData) {
        var itemsWrapped = this._generateAwardsBlockItems(storyData);
        var templateBlockGroups = [
            {
                classes: 'full-desktop',
                anchorName: 'awards-block-group-1-anchor',
                blocks: [
                    {
                        analyticsTrackSeen: this.createAnalyticsTrackSeen(storyData, 1),
                        classes: 'full-desktop story-block-1 story-block-row ',
                        items: [
                            {
                                type: 'link',
                                classes: '',
                                href: storyData.descriptions.logoBlock.link,
                                target: storyData.descriptions.logoBlock.target,
                                analyticsLinkId: this.getStoryAnalyticslinkId(storyData, 1, storyData.descriptions.logoBlock.analyticsLinkId),
                                itemsWrapped: itemsWrapped
                            }
                        ]
                    }
                ]
            }
        ];
        return templateBlockGroups;
    };
    /*
     * Construct Awards block items based on the available content
     * @param {Object} story data
     * @returns {Array} of generated images
     */
    AwardsComponent.prototype._generateAwardsBlockItems = function (storyData) {
        var itemsWrapped = {
            background: [],
            foreground: []
        };
        for (var i = 1; i <= 5; i++) {
            if (storyData.descriptions.logoBlock.media['media' + i]) {
                var item = this.getImageTemplate(storyData.descriptions.logoBlock.media['media' + i], 'background');
                itemsWrapped.background.push(item);
            }
        }
        return itemsWrapped;
    };
    return AwardsComponent;
}(StoryAbstract));
export { AwardsComponent };
